import "../Styles/MakeUp.css";
import hearts from "../../../public/wardrobe/hearts.jpg";
import Container from "./Container";
import SubmitButton from "./SubmitButton";
import Lipgloss from "../../../public/graphics/huulikiilto.png";
import LipLines from "../../../public/graphics/huultenrajaus.png";
import Dialogue from "../Dialogue";
import { useEffect, useRef, useState } from "react";
import ImgRadioButton from "./ImgRadioButton";
import { hideDialogue } from "../../helpers";

/**
 *
 * @typedef {Object} FormRefObject
 * @property {HTMLFormElement} current - The current value of the form reference.
 */

const MakeUpStation = (props) => {
  const [huuletCurrentChecked, setHuuletCurrentChecked] = useState(null);
  const [huulikiiltoCurrentChecked, setHuulikiiltoCurrentChecked] =
    useState(null);
  /**
   * A ref object that holds a reference to the form element.
   *
   * @type {FormRefObject}
   */
  const formRef = useRef();
  //what is selected currently and set it as dialoguetext
  const handleOptionChange = (event) => {
    props.setDialogue(event.target.value);
    if (
      ["punainenluomivari", "oranssiluomivari", "sininenluomivari"].indexOf(
        event.target.name
      ) > -1
    ) {
      setHuuletCurrentChecked(event.target.name);
    }
    if (["huulikiilto", "eihuulikiiltoa"].indexOf(event.target.name) > -1) {
      setHuulikiiltoCurrentChecked(event.target.name);
    }
  };

  const formSubmit = (e) => {
    e.preventDefault();
    // props.setVisibility(false);
    console.log(e.target);
    const data = new FormData(e.target);
    const values = [];
    for (const value of data.entries()) {
      values.push(value[0]);
    }
    props.setSelectedMakeup(values);
    props.setVisibility(false);
    hideDialogue();
  };

  return (
    <>
      {props.visible && (
        <>
          <Container class={"wardrobe-view-container"} headerText={"Meikit"}>
            <p
              style={{
                fontSize: "large",
                fontWeight: "bold",
                textTransform: "uppercase",
                letterSpacing: "1.4px",
              }}
            >
              Valitse luomivärin väri
            </p>

            <form
              ref={formRef}
              onSubmit={formSubmit}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="custom-radio-buttons">
                <input
                  type="radio"
                  name="punainenluomivari"
                  value="Tykkäisköhä Jake harmaasta??"
                  id="red"
                  checked={huuletCurrentChecked === "punainenluomivari"}
                  onChange={handleOptionChange}
                />
                <label htmlFor="red">
                  <span className="color1"></span>
                </label>

                <input
                  type="radio"
                  name="sininenluomivari"
                  value="Britneyl oli sinistä luomiväriä uusimmas lehdes, sopiskoha se lookki mulleki?"
                  id="blue"
                  checked={huuletCurrentChecked === "sininenluomivari"}
                  onChange={handleOptionChange}
                />
                <label htmlFor="blue">
                  <span className="color2"></span>
                </label>

                <input
                  type="radio"
                  name="oranssiluomivari"
                  value="Pronssis ois kyl glitteriä!"
                  id="orange"
                  checked={huuletCurrentChecked === "oranssiluomivari"}
                  onChange={handleOptionChange}
                />
                <label htmlFor="orange">
                  <span className="color3"></span>
                </label>
              </div>
              <p
                style={{
                  fontSize: "large",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "1.4px",
                }}
              >
                Huulet
              </p>
              <div className="selection-container">
                <ImgRadioButton
                  name="huulikiilto"
                  value="Oo tää huulikiilto maistuu iha mansikalt!"
                  handleOptionChange={handleOptionChange}
                  dialogueText={props.dialogueText}
                  setDialogue={props.setDialogue}
                  src={Lipgloss}
                  alt="huulikiilto"
                  checked={huulikiiltoCurrentChecked === "huulikiilto"}
                />
                <ImgRadioButton
                  name="eihuulikiiltoa"
                  handleOptionChange={handleOptionChange}
                  value="Tummat rajaukset on kyl nii in"
                  dialogueText={props.dialogueText}
                  setDialogue={props.setDialogue}
                  src={LipLines}
                  alt="tumma rajaus"
                  checked={huulikiiltoCurrentChecked === "eihuulikiiltoa"}
                />
              </div>
              <SubmitButton
                submit={"handleMakeUpSubmit"}
                isSubmitType={true}
                disabled={!huuletCurrentChecked || !huulikiiltoCurrentChecked}
                submitClicked={() => null}
                text={"Meikit kuosissa"}
                setVisibility={props.setVisibility}
              />
              {/* <Dialogue
              dialogue={props.dialogue}
              setDialogue={props.setDialogue}
            /> */}
            </form>
          </Container>
        </>
      )}
    </>
  );
};

export default MakeUpStation;
